<template>

    <div class="content-preview">
        <div class="navigation">
            <div class="left">
                <div class="back-button" @click="close">
                    <i class="material-icons">arrow_back</i>
                </div>
            </div>
            <div class="right">
                <div class="switch-wrapper" :class="{ active: knowledgeBaseClone.enabled }">
                    <div class="">
                        <div class="title" v-if="knowledgeBaseClone.enabled">{{ $t("chatbotv2.usedByAi") }}</div>
                        <div class="title" v-else>{{ $t("chatbotv2.notUsed") }}</div>
                    </div>
                    <a-switch
                        size="small"
                        :checked="knowledgeBaseClone.enabled"
                        @click="changeState"
                        :disabled="busy"
                    />
                </div>
                <div class="buttons">
                    <SupsisButton small ghost @click="deleteKnowledgeBase" :disabled="busy">
                        <i class="material-icons">delete</i>
                    </SupsisButton>
                    <SupsisButton small ghost disabled>
                        <i class="material-icons">refresh</i>
                    </SupsisButton>
                    <SupsisButton small primary :disabled="!isChanged() || busy" @click="save">
                        {{ $t("chatbotv2.saveAndClose") }}
                    </SupsisButton>
                </div>
            </div>
        </div>
        <div class="scroll-content">
            <div class="doc-title">{{ knowledgeBase.webpage.title }}</div>
            <a :href="knowledgeBase.webpage.url" target="_blank" class="doc-link">
                {{ knowledgeBase.webpage.url }}
            </a>
            <div class="doc-content">
                <div class="content-preview">
                    <i class="material-icons">preview</i>
                    {{ $t("chatbotv2.contentPreview") }}
                </div>
                <i class="material-icons spin" v-if="loading || !data">autorenew</i>
                <div class="tpl-markdown markdown" v-html="data.webpage.htmlContent" v-else />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import { CHATBOT_API } from "../../../../api/chatbotv2";
import _ from "lodash";

export default Vue.extend({
    name: "ContentPreview",
    components: { SupsisButton },
    data() {
        return {
            data: null,
            loading: true,
            knowledgeBaseClone: _.cloneDeep(this.knowledgeBase),
            busy: false,
        };
    },
    props: {
        knowledgeBase: {
            type: Object,
            default: () => ({}),
        },
        storyId: {
            type: String,
            default: "",
        },
    },
    methods: {
        isChanged() {
            return !_.isEqual(this.knowledgeBase, this.knowledgeBaseClone);
        },
        changeState(e) {
            if (e.preventDefault) e.preventDefault();
            if (e.stopPropagation) e.stopPropagation();
            this.knowledgeBaseClone.enabled = !this.knowledgeBaseClone.enabled;
        },
        close() {
            this.$emit("close");
        },
        fetch() {
            this.loading = true;
            CHATBOT_API.KNOWLEDGE_BASE.getKnowledgeBaseById(this.storyId, this.knowledgeBase._id)
                .then((res) => {
                    console.log("getKnowledgeBaseById", res.data);
                    this.data = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        save() {
            this.busy = true;
            const hide = this.$message.loading(
                this.knowledgeBaseClone.enabled
                    ? "Selected knowledge bases are being enabled..."
                    : "Selected knowledge bases are being disabled...",
                0
            );
            CHATBOT_API.KNOWLEDGE_BASE.changeStateMultiKnowledgeBase(
                this.storyId,
                [this.knowledgeBase._id],
                this.knowledgeBaseClone.enabled
            )
                .then((isSuccess) => {
                    if (!isSuccess) return Promise.reject("Failed to change state.");
                    this.$emit("changed", this.knowledgeBaseClone.enabled);
                    this.close();
                })
                .catch((error) => {
                    this.$message.error(
                        this.knowledgeBaseClone.enabled
                            ? "Selected knowledge bases are not enabled."
                            : "Selected knowledge bases are not disabled."
                    );
                })
                .finally(() => {
                    this.busy = false;
                    hide();
                });
        },
        deleteKnowledgeBase() {
            this.busy = true;
            const hide = this.$message.loading("Selected knowledge bases are being deleted...", 0);
            CHATBOT_API.KNOWLEDGE_BASE.deleteMultiKnowledgeBase(this.storyId, [this.knowledgeBase._id])
                .then((isSuccess) => {
                    if (!isSuccess) return Promise.reject("Failed to change state.");
                    this.$emit("deleted");
                })
                .catch((error) => {
                    this.$message.error("Selected knowledge bases are not deleted. Please try again.");
                })
                .finally(() => {
                    this.busy = false;
                    hide();
                });
        },
    },
    mounted() {
        this.fetch();
    },
});
</script>

<style scoped lang="scss">
.content-preview {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    height: 100%;
    position: relative;

    .navigation {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .left {
            display: flex;
            align-items: center;

            .back-button {
                background: #f5f5f5;
                border-radius: 100%;
                height: 32px;
                width: 32px;
                cursor: pointer;
                justify-content: center;
                margin-right: auto;
                transition: all 0.3s;
                display: flex;
                align-items: center;
            }
        }

        .right {
            display: flex;
            align-items: center;
            gap: 5px;

            .switch-wrapper {
                background: #fff;
                border-radius: 15px;
                box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.1);
                display: flex;
                height: 36px;
                padding: 0 8px 0 14px;
                width: 130px;
                align-items: center;
                justify-content: space-between;

                .title {
                    color: #22272d;
                    font-size: 15px;
                    font-weight: 700;
                    line-height: 19px;
                }

                &.active {
                    .title {
                        color: #00893c;
                    }
                }
            }

            .buttons {
                display: flex;
                align-items: center;
                gap: 5px;
            }
        }
    }

    .scroll-content {
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 100%;

        .doc-title {
            color: #22272d;
            display: block;
            font-size: 22px;
            font-weight: 600;
            line-height: 28px;
        }

        .doc-link {
            color: #006cff;
            display: block;
            font-size: 16px;
            line-height: 20px;
            margin-right: auto;
            margin-top: 8px;
            max-width: 100%;
            text-overflow: ellipsis;
            user-select: text;
            white-space: nowrap;
        }

        .doc-content {
            background: #f5f5f5;
            border-radius: 20px;
            margin-bottom: 36px;
            margin-top: 30px;
            padding: 24px;
            position: relative;
            height: 100%;

            .content-preview {
                display: flex;
                font-size: 14px;
                font-weight: 600;
                height: 34px;
                line-height: 18px;
                position: absolute;
                top: -17px;
                width: 168px;
                align-items: center;
                background: #fff;
                border-radius: 20px;
                box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.12);
                color: #000;
                justify-content: center;
                left: 0;
                margin: 0 auto;
                right: 0;
                flex-direction: row;

                i {
                    font-size: 20px;
                    margin-right: 8px;
                }
            }

            .markdown {
                height: 100%;
                overflow-y: auto;
            }
        }
    }
}
</style>
